import { useReactiveVar } from '@apollo/client';
import { setUserDefaults } from 'utility/cache/ui';

function useGetScreenWidth() {
  const userDefaults = useReactiveVar(setUserDefaults);
  const isSm =
    userDefaults?.listviewSize === 'LISTVIEW_SIZE_SMALL';
  const isMd =
    userDefaults?.listviewSize === 'LISTVIEW_SIZE_MEDIUM';
  const isLg =
    userDefaults?.listviewSize === 'LISTVIEW_SIZE_LARGE';
  return {
    isSm,
    isMd,
    isLg,
  };
}

export default useGetScreenWidth;
